export default __webpack_public_path__ + "0a969a9dd6cc1d69c20d12542771523b.svg";